var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skip-width flex w-full h-20 mx-auto"},[_c('div',{staticClass:"ml-auto mr-20"},[_c('span',{staticClass:"text-4xl font-bold cursor-pointer",class:_vm.linkTextColor,on:{"click":_vm.skipForward}},[_vm._v("Skip")])])])}
var staticRenderFns = []

export { render, staticRenderFns }